import { ApolloProvider } from "@apollo/client";
import { clientNeoAuth } from "@neonumy/api-clients";
import { ConfigProvider } from "antd";
import en_GB from "antd/lib/locale/en_GB";
import fr_FR from "antd/lib/locale/fr_FR";
import i18n from "config/i18n/i18n";
import { routes } from "config/routes";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/fr";
import React from "react";
import { I18nextProvider } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import { RouterProvider } from "react-router-dom";

import "@neonumy/neonumy-ui/lib/index.css";
import "resources/styles/main.less";

const CONFIG_TRANSLATIONS = {
  fr: fr_FR,
  en: en_GB,
};
dayjs.locale(i18n.language);

export default function App(): React.ReactElement {
  return (
    <ApolloProvider client={clientNeoAuth}>
      <I18nextProvider i18n={i18n}>
        <ConfigProvider
          locale={CONFIG_TRANSLATIONS[i18n.language as keyof typeof CONFIG_TRANSLATIONS]}
          getPopupContainer={() => document.body}
        >
          <RouterProvider
            router={routes}
            future={{
              v7_startTransition: true,
            }}
          />
        </ConfigProvider>
      </I18nextProvider>
    </ApolloProvider>
  );
}
